import { OlympusClient } from '@/OlympusClient'

import { type CampaignResourceCreate, type CampaignResource } from '../types'

export const createResourceHandler = async ({
  brandId,
  locationId,
  name,
  sections,
}: CampaignResourceCreate): Promise<CampaignResource> => {
  const campaign = await OlympusClient.marketing.v1.campaigns.createCampaign({
    body: {
      brandId,
      conditions: ['sms-subscribed'],
      locationId,
      name,
      transport: 'sms',
      type: 'one-time',
    },
  })

  const { id: smsTemplateId } =
    await OlympusClient.notifications.v1.templates.sms.createSMSTemplate({
      body: {
        brandId,
        locationId,
        name,
      },
    })

  await OlympusClient.notifications.v1.templates.sms.sms.updateSMSTemplate({
    body: { sections },
    params: { smsTemplateId },
  })

  await OlympusClient.marketing.v1.campaigns.campaign.createBlock({
    body: {
      name: null,
      params: {
        expiresAt: null,
        next: null,
        params: {
          templateId: smsTemplateId,
        },
        type: 'send-sms',
      },
      type: 'action',
    },
    params: { campaignId: campaign.id },
  })

  return {
    ...campaign,
    executeAt: campaign.executeAt ? new Date(campaign.executeAt) : null,
    sections,
    smsTemplateId,
  }
}
